@if (cookieConsent.showBanner()) {
  <dialog
    open
    aria-label="Aviso de cookies"
    class="fixed bottom-0 left-0 right-0 z-[200] w-full max-w-none m-0 p-0 border-none bg-transparent animate-slide-up-bar">
    <div class="bg-white border-t border-[#C1C1C3] shadow-[0_-4px_24px_rgba(0,0,0,0.08)] px-6 md:px-14 py-5">
      <div
        class="max-w-[1300px] mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 md:gap-32">
        <p class="font-roboto text-base text-[#35353C] leading-relaxed">
          Usamos cookies esenciales para el funcionamiento de la plataforma. Con tu consentimiento, también usamos
          cookies de analítica para mejorar la experiencia. Consulta nuestra
          <a routerLink="/legal/privacidad" class="text-[#2563eb] underline hover:text-[#1e40af]"
            >Política de Privacidad</a
          >.
        </p>
        <div class="flex items-center gap-3 shrink-0">
          <button
            type="button"
            (click)="rejectNonEssential()"
            class="font-roboto text-sm text-[#35353C] bg-transparent border border-[#C1C1C3] px-4 py-2 rounded-md cursor-pointer transition-colors duration-200 hover:border-[#35353C]">
            Solo esenciales
          </button>
          <button
            type="button"
            (click)="acceptAll()"
            class="font-roboto text-sm font-semibold text-white bg-[#2563eb] border-none px-5 py-2 rounded-md cursor-pointer transition-all duration-200 hover:bg-[#1e40af]">
            Aceptar todas
          </button>
        </div>
      </div>
    </div>
  </dialog>
}
